export { getTrialPeriodDays } from '@kit/shared/config';

/** Registry URLs for verification */
export const DOCTOR_REGISTRY_URL = 'https://rejestr.nil.org.pl';
export const PHARMACIST_REGISTRY_URL = 'https://crf.ezdrowie.gov.pl/Search';
export const NURSE_MIDWIFE_REGISTRY_URL = 'https://nipip.pl/weryfikacja-pwz';
